import moment from 'moment';

export default {
  name: 'SubscriptionEnd',
  data() {
    return {
        dataAccess: null,
        endDate: null,
    }
  },
  async created() {
    this.dataAccess = this.$store.getters.dataAccess;
    this.endDate = this.$store.getters.subscriptionEndAt;
  },
  methods: {
    getExpiredDate(){
        if(this.endDate){
            return new moment(this.endDate).format('YYYY/MM/DD HH:mm');
        }else{
            return 'N/A';
        }
    },
  }
};
